import React from "react";
import { Zap } from "lucide-react";
import useReveal from "../hooks/useReveal";
import { developerApi } from "../mock";
import useBranding from "../hooks/useBranding";
import { brandText } from "../utils/brand";

const DeveloperAPI = () => {
  const [ref, inView] = useReveal();
  const b = useBranding();

  return (
    <section
      className="relative py-24 md:py-32 overflow-hidden"
      style={{ background: "linear-gradient(135deg, #050C17 0%, #0D1B2A 55%, #123f74 100%)" }}
    >
      {/* Decorative grid glow */}
      <div className="absolute inset-0 opacity-[0.12]" style={{ backgroundImage: "radial-gradient(circle at 20% 30%, #38BDF8 0, transparent 40%), radial-gradient(circle at 80% 70%, #06B6D4 0, transparent 35%)" }} />

      <div ref={ref} className="pp-container relative grid lg:grid-cols-2 gap-14 items-center">
        {/* Phone / code mock */}
        <div className={`relative pp-reveal ${inView ? "pp-in" : ""}`}>
          <div className="relative mx-auto w-[290px] rounded-[38px] bg-black border-[10px] border-slate-800 shadow-2xl p-5 pt-8 pp-float">
            <div className="absolute top-3 left-1/2 -translate-x-1/2 w-24 h-1.5 bg-slate-700 rounded-full" />
            <div className="flex items-center gap-2 text-white font-bold text-lg mb-4">
              <Zap size={18} className="text-[#06B6D4] fill-[#06B6D4]" /> {b.company_name}
            </div>
            <div className="font-mono text-[11px] leading-relaxed space-y-1">
              {developerApi.code.map((line, i) => (
                <div key={i} className={line.startsWith("//") ? "text-[#4ade80]" : line.includes("success") || line.includes("true") ? "text-[#10B981]" : "text-[#7cc4ff]"}>
                  {brandText(line, b.company_name) || "\u00A0"}
                </div>
              ))}
            </div>
            <div className="mt-6 h-2 rounded-full bg-slate-800 overflow-hidden">
              <div className="h-full bg-[#06B6D4]" style={{ animation: "pp-progress 3s ease-in-out infinite" }} />
            </div>
          </div>
        </div>

        {/* Text card */}
        <div className={`relative rounded-3xl border border-white/10 bg-white/[0.04] backdrop-blur-sm p-9 md:p-11 pp-reveal ${inView ? "pp-in" : ""}`} style={{ animationDelay: "0.15s" }}>
          <span className="inline-flex items-center gap-2 text-[#10B981] font-semibold uppercase tracking-wider text-xs md:text-sm">
            <Zap size={16} className="fill-[#10B981]" /> {developerApi.tag}
          </span>
          <h2 className="mt-4 text-3xl md:text-5xl font-extrabold leading-[1.1] text-white">
            {developerApi.title}{" "}
            <span className="pp-grad-text-orange">{developerApi.titleHi}</span>
          </h2>
          <p className="mt-6 text-white/70 leading-relaxed">{brandText(developerApi.body, b.company_name)}</p>
        </div>
      </div>
    </section>
  );
};

export default DeveloperAPI;
